import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpEventLoaderService {
  private concurrentReq = signal<number>(0);
  isLoading = computed(() => this.concurrentReq() !== 0);

  show() {
    this.concurrentReq.update((oldValue) => oldValue + 1);
  }

  hide() {
    this.concurrentReq.update((oldValue) => oldValue - 1);
  }
}
